const ids = (values) => [...new Set((values || []).map(Number).filter((id) => id > 0))];
export const equipmentKey = (value) => String(value || "").trim().toLowerCase();
const metric = (ex) => ex.metric_type || "weight_reps";

/** Rank catalog matches by primary-muscle coverage, then movement and equipment.
 * Secondary-only overlap is never a substitute for the original primary target.
 * Scores are sorting aids, deliberately not presented as scientific percentages.
 */
export function exerciseAlternatives(source, library, { equipment = "", query = "", existing = [] } = {}) {
  const primary = ids(source.primary_muscle_ids);
  if (!primary.length) return [];
  const secondary = ids(source.secondary_muscle_ids);
  const excluded = new Set([source.library_exercise_id ?? source.id, ...existing].map(String));
  const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return library.flatMap((ex) => {
    if (excluded.has(String(ex.id))) return [];
    if (equipment && equipmentKey(ex.equipment) !== equipmentKey(equipment)) return [];
    if (!words.every((word) => ex.exercise_name.toLowerCase().includes(word))) return [];
    // Keep strength, stretching and cardio in their own categories when known.
    if (source.category && ex.category && source.category !== ex.category) return [];
    const targets = ids(ex.primary_muscle_ids);
    const shared = primary.filter((id) => targets.includes(id));
    if (!shared.length) return [];
    const exact = shared.length === primary.length && shared.length === targets.length;
    const sameEquipment = !!equipmentKey(source.equipment) && equipmentKey(source.equipment) === equipmentKey(ex.equipment);
    const score = shared.length / primary.length * 100 + shared.length / targets.length * 30
      + (source.mechanic && source.mechanic === ex.mechanic ? 12 : 0)
      + (source.force && source.force === ex.force ? 8 : 0)
      + (metric(source) === metric(ex) ? 6 : 0)
      + (sameEquipment ? 5 : 0)
      + secondary.filter((id) => ids(ex.secondary_muscle_ids).includes(id)).length * 2;
    return [{ exercise: ex, shared, exact, sameEquipment, score }];
  }).sort((a, b) => Number(b.exact) - Number(a.exact) || b.score - a.score || a.exercise.exercise_name.localeCompare(b.exercise.exercise_name) || a.exercise.id - b.exercise.id);
}
